import {configureStore} from "@reduxjs/toolkit";
import {inMemoryPlusStatusReducer, inMemoryPlusStatusSliceName} from "../reusables/plus/APXPlus.js";
import inMemoryIndustryReducer, {inMemoryIndustrySliceName} from "./InMemoryIndustryReducer.js";


const store = configureStore({
	  reducer: {
			 [inMemoryIndustrySliceName]: inMemoryIndustryReducer,
			 [inMemoryPlusStatusSliceName]: inMemoryPlusStatusReducer
	  }
});

export default store;
